import { themeBuilder } from "@cybs-plugins/theme";
import 'font-awesome/css/font-awesome.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '@visa/nova-styles/styles.css';
import '@visa/nova-styles/themes/visa-dark-alt/index.css';
import './index.css';
import storeThemeData from './themeprovider/actions/themes-provider';
import ParentComponent from './parent';
import { getDevCenterDataStore } from './app/store';
import { connect, Provider } from 'react-redux';
import { storeConfigData } from "./lhs/actions/configuration-actions";
import {putDataInDevCenterDataStore} from './app/store';

var CUSTOM_CSS = "";

var Nodes = [];
var apiReferencePage = document.getElementById('root');
var widgets = document.getElementsByClassName('apiReferenceWidget');

if(apiReferencePage){
	Nodes.push(apiReferencePage);
	putDataInDevCenterDataStore({type:'UPDATE_IS_WIDGET', isWidget: false});
}

Array.prototype.forEach.call(widgets, function(node) {
	Nodes.push(node);
	putDataInDevCenterDataStore({type:'UPDATE_IS_WIDGET', isWidget: true});
});

storeConfigData();
storeThemeData();

Nodes.forEach(node => {
	const root = createRoot(node);
	root.render(
		<React.StrictMode>
		<Provider store={getDevCenterDataStore()}>
			<ParentComponent node={node}/>
			</Provider>
 		</React.StrictMode>,
		node
	);
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
